export const filterProfilesByOrg = (profiles, organization) => {
  if (!organization) {
    return profiles;
  }
  return profiles?.filter(
    (profile) => profile.organizationId === organization.id
  );
};
